"use client";

import { Resources } from "@/types/subject-schema";
import { Title } from "@mantine/core";
import { getAllowedResourcesForSubject } from "@utils/routing";
import { capAll } from "../../../../../../lib/strapi/formatters";
import ResourceCard from "../ResourceCard";
import CustomGridWrapper from "./CustomGridWrapper";
import classes from "./ResourceGridLayout.module.css";

const topicResources: Resources[] = [
  "videos",
  "notes",
  "definitions",
  "flashcards",
  "questions",
  "cram sheets",
  "topic tests",
  "mock exams",
  "test builder",
];
const usefulResources: Resources[] = [
  "syllabus",
  "exam breakdown",
  "ia examples",
  "ia criteria",
  "command terms",
  "test taker",
];

export default function ResourceGridLayout({
  subjectNameLower,
}: {
  subjectNameLower: string;
}) {
  return (
    <>
      <Title order={2} className={classes.title}>
        IB {capAll(subjectNameLower)} Core Resources
      </Title>
      <CustomGridWrapper animate>
        {filterResourcesToShow(subjectNameLower, topicResources).map((r) => (
          <ResourceCard
            key={r}
            resource={r}
            subjectNameLower={subjectNameLower}
          />
        ))}
      </CustomGridWrapper>
      <Title order={2} className={classes.title} mt={"15vh"}>
        IB {capAll(subjectNameLower)} Useful Resources
      </Title>
      <CustomGridWrapper animate>
        {filterResourcesToShow(subjectNameLower, usefulResources).map((r) => (
          <ResourceCard
            key={r}
            resource={r}
            subjectNameLower={subjectNameLower}
          />
        ))}
      </CustomGridWrapper>
    </>
  );
}

function filterResourcesToShow(
  subjectNameLower: string,
  resourcesToShow: Resources[]
) {
  const allowedResources = new Set(getAllowedResourcesForSubject(subjectNameLower));
  return resourcesToShow.filter((resource) => allowedResources.has(resource));
}
